import React from 'react';
import Layout from '../components/Layout';
import GlobalAuthorizationLayout from '../components/GlobalAuthorizationLayout';
import Statistics from '../apps/Statistics';
import CheckStaffUserLayout from '../layout/CheckStaffUserLayout';
import CheckViewer from '../layout/CheckViewer';

const StatisticsPage: React.FC = () => {
  return (
    <GlobalAuthorizationLayout>
      <CheckStaffUserLayout>
        <CheckViewer>
          <Layout>
            <div>
              <Statistics />
            </div>
          </Layout>
        </CheckViewer>
      </CheckStaffUserLayout>
    </GlobalAuthorizationLayout>
  );
};

export default StatisticsPage;
